import { HTTP } from '../helpers/http-common.js'
import authHeader from '../helpers/auth-header'
import helpers from '../helpers/helpers'


const salespeopleService = {
    getSalespeople,
    storeSalesperson,
    updateSalesperson,
    getSalesperson,
    deleteSalesperson
};

export default salespeopleService

function getSalespeople(page = 0, search = {}) {

  let params = '';
  
  if(search.term) {
    params += `&search=${search.term}`;
  }

  if(search.options) {
    params += `&options=${search.options}`
  }

  if(search.perPage) {
    params += `&perPage=${search.perPage}`
  }

  return HTTP.get(`salespeople?page=${page}${params}`, {
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}

function getSalesperson(id) {
  return HTTP.get(`salesperson/${id}`, {
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()

    }
  });
}

function storeSalesperson(item = {}) {
  return HTTP({
    method: 'post',
    url: 'store-salesperson',
    data: item,
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()

    }
  });
}

function updateSalesperson(item = {}) {
  return HTTP({
    method: 'post',
    url: 'update-salesperson',
    data: item,
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}

function deleteSalesperson(id) {
  return HTTP({
    method: 'post',
    url: 'delete-salesperson',
    data: {id: id},
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}